import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordPension, EmploymentRecordPensionSubmit } from '../models/employment-record-pension.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordPensionsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getPensions(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Pension`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            pensions: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getPension(employeeId: string, employmentRecordId: string, pensionId: string): Observable<EmploymentRecordPension> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Pension/${pensionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postPension(employeeId: string, employmentRecordId: string, pension: EmploymentRecordPensionSubmit): Observable<EmploymentRecordPension> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Pension`, pension, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deletePension(employeeId: string, employmentRecordId: string, pensionId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Pension/${pensionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

